import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  Input
} from '@angular/core';
import { Observable } from 'rxjs';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  DealVersion,
  OrderPeriodType,
  OrderPeriodOrderTypeIndicator,
  DealType
} from '../../types/deal.types';
import { IssueOrderPeriod } from '../../helpers/issue/order-period';
import { DealTypeVersion } from '../../helpers/issue/type';
import {
  OrderPeriodCountdownService,
  DealToCountdownMapper
} from '../../services/issue/order-period-countdown.service';
import { map } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'muni-shared-order-period',
  templateUrl: './order-period.component.html',
  styleUrls: ['./order-period.component.scss'],
  providers: [OrderPeriodCountdownService],
  standalone: false,
})
export class OrderPeriodComponent
  implements ICellRendererAngularComp, OnInit, OnDestroy {
  @Input() public deal: DealVersion;

  public countdown$: Observable<IssueOrderPeriod.OrderPeriodCountdown>;

  public orderType$: Observable<OrderPeriodType>;

  private params: ICellRendererParams;

  constructor(
    private readonly countdownService: OrderPeriodCountdownService<DealVersion>
  ) {}

  public get isCompetitive(): boolean {
    return DealTypeVersion.isCompetitive(
      this.deal || (this.params.data as DealVersion)
    );
  }

  public get getDealType(): DealType {
    if (this.deal) {
      return this.deal.dealType;
    }
    return this.params && this.params.data && this.params.data.dealType;
  }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }

  public ngOnInit() {
    if (!this.countdown$) {
      if (this.deal) {
        this.countdown$ = this.countdownService.subscribe(
          this.deal as DealVersion,
          IssueOrderPeriod.getCountdown as DealToCountdownMapper<DealVersion>
        );
      } else if (this.params && this.params.data) {
        this.countdown$ = this.countdownService.subscribe(
          this.params.data as DealVersion,
          IssueOrderPeriod.getCountdown as DealToCountdownMapper<DealVersion>
        );
      }
    }
    this.orderType$ = this.countdown$.pipe(
      map(countdown =>
        countdown.type === 'All'
          ? !!countdown.orderTypes &&
            !!countdown.orderTypes.filter(
              t =>
                t.orderType === OrderPeriodOrderTypeIndicator.retail &&
                t.priority === 1
            ).length
            ? OrderPeriodType.retail
            : OrderPeriodType.all
          : countdown.type
      )
    );
  }

  public ngOnDestroy(): void {
    this.countdownService.unsubscribe();
  }
}
